(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-rope-size-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hh-rope-finder')) {
  customElements.define('hh-rope-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) { this.setupMotion(); return; }
      this.ready = true;
      this.unit = 'cm';
      this.canonicalHeight = null;
      this.dirty = true;
      this.q = (s) => this.querySelector(s);
      this.copy = Object.fromEntries(Array.from(this.querySelectorAll('[data-key]')).map(el => [el.dataset.key, el.textContent]));
      this.inputs = Array.from(this.querySelectorAll('input'));
      this.q('[type=submit]').disabled = false;
      this.q('[data-form]').addEventListener('submit', e => { e.preventDefault(); this.calculate(); });
      this.inputs.forEach(el => el.addEventListener('input', () => {
        this.dirty = true;
        this.canonicalHeight = null;
        this.clearError();
        this.hideResult();
      }));
      this.querySelectorAll('[data-unit]').forEach(el => el.addEventListener('click', () => this.switchUnit(el.dataset.unit)));
      this.q('[data-motion-toggle]').addEventListener('click', () => {
        this.motionPaused = !this.motionPaused;
        this.updateMotion();
      });
      this.setupMotion();
    }
    setupMotion() {
      this.motionAbort?.abort();
      this.motionObserver?.disconnect();
      this.motionAbort = new AbortController();
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motionVisible = true;
      const signal = this.motionAbort.signal;
      this.motionPreference.addEventListener('change', () => this.updateMotion(), { signal });
      document.addEventListener('visibilitychange', () => this.updateMotion(), { signal });
      if ('IntersectionObserver' in window) {
        this.motionObserver = new IntersectionObserver(entries => {
          this.motionVisible = entries[0].isIntersecting;
          this.updateMotion();
        });
        this.motionObserver.observe(this.q('.hh-rope__animation'));
      }
      this.updateMotion();
    }
    updateMotion() {
      const reduced = this.motionPreference.matches;
      this.dataset.motion = !reduced && !this.motionPaused && this.motionVisible && !document.hidden ? 'playing' : 'paused';
      const button = this.q('[data-motion-toggle]');
      button.hidden = reduced;
      button.textContent = this.copy[this.motionPaused ? 'play_animation' : 'pause_animation'];
    }
    disconnectedCallback() {
      this.motionAbort?.abort();
      this.motionObserver?.disconnect();
      this.dataset.motion = 'paused';
    }
    clearError() {
      this.q('[data-error]').hidden = true;
      this.inputs.forEach(el => el.removeAttribute('aria-invalid'));
    }
    hideResult() {
      this.q('[data-result]').hidden = true;
      this.q('[data-empty]').hidden = false;
      this.q('[data-announcement]').textContent = '';
    }
    readHeight() {
      const cm = this.q('[data-cm]'), ft = this.q('[data-ft]'), inch = this.q('[data-in]');
      if (this.unit === 'cm') {
        if (cm.value.trim() === '' || !Number.isFinite(cm.valueAsNumber)) return { error: 'error_empty', field: cm };
        return { value: cm.valueAsNumber };
      }
      if (ft.value.trim() === '' || !Number.isInteger(ft.valueAsNumber) || ft.valueAsNumber < 0) return { error: 'error_empty', field: ft };
      const i = inch.value === '' ? 0 : inch.valueAsNumber;
      if (!Number.isFinite(i) || i < 0 || i >= 12) return { error: 'error_inches', field: inch };
      return { value: (ft.valueAsNumber * 12 + i) * 2.54 };
    }
    switchUnit(next) {
      if (next === this.unit) return;
      const current = this.readHeight();
      const valid = !current.error && current.value >= 80 && current.value <= 230;
      const height = valid ? (this.canonicalHeight ?? current.value) : null;
      if (height !== null) {
        this.canonicalHeight = height;
        if (next === 'cm') this.q('[data-cm]').value = Number(height.toFixed(2));
        else {
          const total = Math.round(height / 2.54 * 100) / 100;
          this.q('[data-ft]').value = Math.floor(total / 12);
          this.q('[data-in]').value = Number((total % 12).toFixed(2));
        }
      } else {
        this.inputs.forEach(el => { el.value = ''; });
        this.canonicalHeight = null;
        this.hideResult();
      }
      this.unit = next;
      this.q('[data-cm-wrap]').hidden = next !== 'cm';
      this.q('[data-ft-wrap]').hidden = next !== 'ft';
      this.querySelectorAll('[data-unit]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.unit === next)));
      this.clearError();
    }
    calculate() {
      this.clearError();
      const data = this.readHeight();
      if (!data.error && (data.value < 80 || data.value > 230)) {
        data.error = 'error_range'; data.field = this.q(this.unit === 'cm' ? '[data-cm]' : '[data-ft]');
      }
      if (data.error) {
        this.hideResult();
        this.q('[data-error]').textContent = this.copy[data.error];
        this.q('[data-error]').hidden = false;
        data.field.setAttribute('aria-invalid', 'true');
        data.field.focus();
        return;
      }
      const height = this.canonicalHeight ?? data.value;
      this.canonicalHeight = height;
      const rawLength = Number((height + Number(this.dataset.offset)).toFixed(8));
      const length = rawLength >= 284 ? Math.round(rawLength) : rawLength;
      const displayed = Number(length.toFixed(2));
      const totalInches = Math.round(length / 2.54);
      this.q('[data-length]').textContent = displayed;
      this.q('[data-imperial]').textContent = `${this.copy.approx} ${Math.floor(totalInches / 12)} ${this.copy.feet_short} ${totalInches % 12} ${this.copy.inches_short}`;
      let count = 0;
      this.querySelectorAll('[data-model]').forEach(el => {
        const max = Number(el.dataset.max);
        const known = Number.isFinite(max) && max > 0;
        const enough = known && length <= max + 1e-8;
        el.dataset.state = !known ? 'unknown' : enough ? 'enough' : 'short';
        el.querySelector('[data-status]').textContent = this.copy[!known ? 'unconfirmed' : enough ? 'available' : 'short'];
        const link = el.querySelector('[data-product-link]');
        if (link) link.hidden = !enough;
        if (enough) count++;
      });
      this.q('[data-none]').hidden = count !== 0;
      this.q('[data-contact]').hidden = count !== 0;
      this.q('[data-collection]').hidden = count === 0;
      this.q('[data-empty]').hidden = true;
      this.q('[data-result]').hidden = false;
      if (window.matchMedia('(max-width: 749px)').matches) this.q('[data-result]').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
      this.q('[data-announcement]').textContent = `${this.copy.announcement} ${displayed} cm. ${this.q('[data-imperial]').textContent}. ` + Array.from(this.querySelectorAll('[data-model]')).map(el => `${el.querySelector('h4').textContent}: ${el.querySelector('[data-status]').textContent}`).join('. ');
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
